// dietasocial.it/percorsi?percorso=<code> (client, 08/10/2026): the Hub, an ad
// or a message opens one percorso's window in the app. The code is the CRM's
// «Codice link app» (protocols.app_link_code), sent with every percorso of the
// list, so a new percorso needs no app update.

export const JOURNEY_CODE_PARAM = "percorso";
// Lowercase words joined by hyphens, as the CRM accepts them.
export const JOURNEY_CODE_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const MAX_CODE_LENGTH = 50;

/** The code from a query string, lowercased; null when missing or malformed. */
export const journeyCodeFromSearch = (search) => {
  let raw = "";
  try {
    raw = new URLSearchParams(search || "").get(JOURNEY_CODE_PARAM) || "";
  } catch {
    return null;
  }
  const code = raw.trim().toLowerCase();
  return code && code.length <= MAX_CODE_LENGTH && JOURNEY_CODE_RE.test(code)
    ? code
    : null;
};

/** The same query string without the code (the window opens once, not on every back/refresh). */
export const withoutJourneyCode = (search) => {
  const params = new URLSearchParams(search || "");
  params.delete(JOURNEY_CODE_PARAM);
  const rest = params.toString();
  return rest ? `?${rest}` : "";
};

/** The percorso of the list with this «Codice link app», or null. */
export const findProtocolByLinkCode = (protocols, code) =>
  (Array.isArray(protocols) ? protocols : []).find(
    (p) => String(p?.app_link_code || "").toLowerCase() === code,
  ) || null;

// Names for the message when the percorso isn't in the list at that moment
// (between two cycles, no menus yet, or not for this member's sex): the list
// can't name it then. The codes seeded on 09/10/2026.
const JOURNEY_NAMES = {
  metabolico: "Metabolico",
  antinfiammatorio: "Antinfiammatorio",
  "salute-epatica": "Salute Epatica",
  cardioprotettivo: "Cardioprotettivo",
  gastroprotettivo: "Gastroprotettivo",
  linfodrenante: "Linfodrenante",
  ripartenza: "Ripartenza",
  "anti-gonfiore": "Anti-Gonfiore",
  menopausa: "Menopausa",
};

/** Client's wording, 08/10/2026. */
export const journeyUnavailableMessage = (code) =>
  Object.prototype.hasOwnProperty.call(JOURNEY_NAMES, code)
    ? `Il percorso ${JOURNEY_NAMES[code]} al momento non è disponibile: ecco i percorsi attivi.`
    : "Il percorso richiesto al momento non è disponibile: ecco i percorsi attivi.";
